import React from "react";
import { FaBox, FaRupeeSign, FaExclamationTriangle } from "react-icons/fa";
import StockHealthCard from "./StockHealthCard";
import InventoryValueContribution from "./InventoryValueContribution";
import InventorySummaryCard from "./InventorySummaryCard";

const InventoryAnalysis = () => {
    return (
        <>
            <h1 className="text-2xl md:text-3xl font-bold my-6 text-gray-800">
                Inventory Analysis
            </h1>

            <div className="grid grid-cols-1 lg:grid-cols-2  gap-4 my-4">
                <div>
                    <InventorySummaryCard />

                    <InventoryValueContribution />
                </div>

                <div className="self-start">
                    <StockHealthCard />
                </div>
            </div>
        </>
    );
};

export default InventoryAnalysis;
